import { css } from 'linaria';

export const authorBlock = css`
  display: flex;
  flex-direction: column;
`;

export const firstRow = css``;

export const authorContainer = css`
  display: flex;
  align-items: center;
`;

export const personTitle = css`
  margin-inline-start: 12px;
`;

export const ratingWrapper = css`
  display: flex;
  align-items: center;
`;

export const textRow = css`
  display: flex;
`;

export const textRowProsCons = css`
  display: flex;
  flex-flow: row wrap;
`;

export const prosConsLabel = css`
  flex-shrink: 0;
  padding-right: 4px;
`;

export const prosConsContent = css`
  display: flex;
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 100%;
  margin: 0;
`;

export const likeDislikeGroupWrapper = css`
  margin-top: var(--space-50);
`;

export const reviewAdditionalInfoWrapper = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-150);
`;
